import { storeData, get_master_auth_key, get_auth_key, getStoredData } from '../util';

export const upsertLocalStorageDetails = (data, type) => {
  const storageKey = type === 'master' ? get_master_auth_key() : get_auth_key();
  const existingData = getStoredData(storageKey);
  if (existingData) {
    const existingDataObject = JSON.parse(existingData);
    storeData(
      storageKey,
      JSON.stringify({
        ...existingDataObject,
        ...data,
      })
    );
  } else {
    storeData(storageKey, JSON.stringify(data));
  }
};
